import React, { useState, useContext } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import SearchIcon from '@mui/icons-material/Search';
import TextField from "@mui/material/TextField";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ClearIcon from "@mui/icons-material/Clear";
import OutlinedInput from "@mui/material/OutlinedInput";
import './SearchVehicleByParamsContainer.scss';
import { SearchVehicleByParamsDataContext } from '../SearchVehicleByParamsDataProvider';
import LaximoVehicleContainer from '../../LaximoVehicleContainer/LaximoVehicleContainer';

const Vehicle = ({ catalog, vehicle, findVehicle }) => {
    return (
        <div>
            <Typography variant="h6">{vehicle.brand}</Typography>
            <Typography variant="subtitle1">{vehicle.model}</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        {
                            vehicle.data[0].attributes.map((attribute, key) => {
                                return (<TableCell key={'attr-' + key} className="cell">{attribute.label}</TableCell>);
                            })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        vehicle.data.map((attr, i) => {
                            return (
                                <TableRow key={'row-' + i} className="table-row">
                                    {
                                        attr.attributes.map((attribute, key) => {
                                            return (
                                                attribute.key === 'date'
                                                    ? <TableCell key={'attr-' + key} style={{ textAlign: 'center', }} onClick={() => findVehicle(attr.id, attr.ssd)}>{'c ' + attribute.value.from + ' по ' + attribute.value.to}</TableCell>
                                                    : <TableCell key={'attr-' + key} style={{ textAlign: 'center', }} onClick={() => findVehicle(attr.id, attr.ssd)}>{attribute.value}</TableCell>
                                            );
                                        })
                                    }
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            </Table>
        </div>
    );
};

const Vehicles = ({ vehicles, catalog, findVehicle }) => {
    return vehicles.map(vehicle => (
        <Grid key={vehicle.id} item xs={12}>
            <Vehicle catalog={catalog} vehicle={vehicle} findVehicle={findVehicle} />
        </Grid>
    ))
};

const CatalogInfo = ({ catalogData, changeCatalogSsd }) => {
    if (catalogData.options.length === 0) return (
        <TextField className="option-field" value={catalogData.value} disabled variant="outlined" label={catalogData.name} />
    );

    return (
        <FormControl
            variant="outlined"
            className="form-control"
        >
            <InputLabel htmlFor="outlined-input">
                {catalogData.name}
            </InputLabel>
            <Select
                variant="outlined"
                native
                input={
                    <OutlinedInput
                        label={catalogData.name}
                    />
                }
                onChange={event => changeCatalogSsd(event.target.value)}
            >
                <option value=""></option>
                {catalogData.options.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </Select>
        </FormControl>
    );
}

const BrandSelector = ({ brands, brand, changeBrand }) => {
    const [code, setCode] = useState(brand);

    const changeCode = (code) => {
        setCode(code);
        changeBrand(code, '');
    }

    return (
        <FormControl className="form-control brand-selector">
            <InputLabel>Марка машины</InputLabel>
            <Select
                variant="outlined"
                value={code || ''}
                onChange={(event) => changeCode(event.target.value)}
                displayEmpty
            >
                <MenuItem value=""><em></em></MenuItem>
                {
                    brands.map((brand) => {
                        return (<MenuItem key={brand.id} value={brand.value}>{brand.value}</MenuItem>);
                    })
                }
            </Select>
        </FormControl>
    );
}

/**
 * Контейнер страницы поиска автомобиля по параметрам
 * @returns {JSX.Element}
 */
export const SearchVehicleByParamsContainer = () => {
    const { brands, brand, catalogInfo, vehicles, vehicle, catalogSsd, showVehicles, showCatalogInfo, setShowVehicles, setShowCatalogInfo, setCatalogSsd, setBrand, setVehicleId, setVehicleSsd } = useContext(SearchVehicleByParamsDataContext);

    const changeBrand = (brand) => {
        setBrand(brand);
        setCatalogSsd('');
    };

    const clear = () => {
        setCatalogInfo([]);
        setCatalogSsd('');
    };

    const findVehicles = (brand, ssd) => {
        console.log(brand, ssd);
    };

    const findVehicle = (id, ssd) => {
        setVehicleId(id);
        setVehicleSsd(ssd);
    };

    return (
        <div className="search-vehicle-by-params">
            <div className="pageCard">
                <Grid container style={{ marginBottom: 15, }}>
                    <Grid item xs={6} style={{ padding: 16, paddingLeft: 24, }}>
                        {brands.length ? <BrandSelector brands={brands} brand={brand} changeBrand={changeBrand} /> : null}
                    </Grid>
                    <Grid item xs={6} />
                </Grid>
                <Grid container style={{ marginBottom: 15, }}>
                    {
                        catalogInfo.length
                            ? <div className="toggle-section-box">
                                <Grid item xs={12} className="toggle-section">
                                    <Button
                                        // variant="extendedFab"
                                        onClick={() => setShowCatalogInfo(!showCatalogInfo)}
                                        className={`toggle-button ${!showCatalogInfo && "toggle-button__open"}`}
                                        // color={showCatalogInfo ? 'default' : 'primary'}
                                        startIcon={showCatalogInfo ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                    >
                                    </Button>
                                    {!showCatalogInfo ? 'Показать выбор параметров' : 'Скрыть выбор параметров'}
                                </Grid>
                            </div>
                            : null
                    }
                    {
                        catalogInfo.length && showCatalogInfo
                            ? <div className="catalog-box">
                                <Grid item xs={6} style={{ padding: 8, paddingLeft: 24, }}>
                                    <div className="catalog-options">
                                        {catalogInfo.map(catalogData => <div className="option-item">
                                            <CatalogInfo key={catalogData.conditionId} catalogData={catalogData} changeCatalogSsd={setCatalogSsd} />
                                        </div>)}
                                        <div className="actions">
                                            <Button
                                                onClick={() => findVehicles(brand, catalogSsd)}
                                                className="search-button"
                                                variant="contained"
                                                color="secondary"
                                                startIcon={<SearchIcon />}
                                            >
                                                Найти
                                            </Button>
                                            <Button
                                                onClick={clear}
                                                className="cancel-button"
                                                variant="outlined"
                                                color="primary"
                                                startIcon={<ClearIcon />}
                                            >
                                                Очистить
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>
                            </div>
                            : null
                    }
                </Grid>
                <Grid container style={{ marginBottom: 15, }}>
                    {
                        Object.keys(vehicles).length
                            ? <div className="toggle-section-box">
                                <Grid item xs={12} className="toggle-section">
                                    <Button
                                        // variant="extendedFab"
                                        onClick={() => setShowVehicles(!showVehicles)}
                                        className={`toggle-button ${!showVehicles && "toggle-button__open"}`}
                                        // color={showVehicles ? 'default' : 'primary'}
                                        startIcon={showVehicles ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                    >
                                    </Button>
                                    {!showVehicles ? 'Показать список автомобилей' : 'Скрыть список автомобилей'}
                                </Grid>
                            </div>
                            : null
                    }
                    {
                        Object.keys(vehicles).length && showVehicles
                            ? <Grid container>
                                <Grid item xs={12} className="vehicles-section">
                                    <Vehicles vehicles={vehicles} catalog={catalogInfo} findVehicle={findVehicle} />
                                </Grid>
                            </Grid>
                            : null
                    }
                </Grid>
                <Grid container style={{ marginBottom: 15, }}>
                    {
                        Object.keys(vehicle).length
                            ? <Grid container>
                                <Grid item xs={12}>
                                    <LaximoVehicleContainer vehicle={vehicle} />
                                </Grid>
                            </Grid>
                            : null
                    }
                </Grid>
            </div>
        </div>
    );
};
